import { PanelLeft, Search, X } from 'lucide-react';
import clsx from 'clsx';
import ChatHistory from '../chat/ChatHistory';
import { useNavigate } from 'react-router-dom';
import MESSAGE_ICON from '../../assets/Images/message-icon.png';
import { useState } from 'react';
import { useAuth } from '../../context/AuthProvider';
import { useChat } from '../../context/ChatContext';

export default function Sidebar({
  isOpen,
  setIsOpen,
  collapsed,
  toggleCollapse,
}) {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [isSearchOn, setIsSearchOn] = useState(false);
  const { logout } = useAuth();
  const { setActiveChatId, activeChatId } = useChat();

  return (
    <>
      {/* Mobile backdrop */}
      <div
        className={clsx(
          'fixed inset-0 z-30 bg-black bg-opacity-50 lg:hidden transition-opacity',
          isOpen ? 'block' : 'hidden'
        )}
        onClick={() => setIsOpen(false)}
      />
      {/* Sidebar */}
      <div
        className={clsx(
          'fixed z-40 inset-y-0 left-0 bg-[#f7f7f7] shadow-md transition-all',
          collapsed ? 'w-0' : 'w-64 p-4',
          'transform lg:translate-x-0 lg:static lg:inset-0',
          isOpen ? 'translate-x-0' : '-translate-x-full',
          'lg:block'
        )}
      >
        <div className="flex flex-col justify-between gap-3 lg:gap-6">
          {/* Top Bar */}
          <div className="items-center justify-between hidden h-[45px] gap-2 lg:flex p-2">
            {!isSearchOn && (
              <PanelLeft
                className="text-[#7a7c7c] cursor-pointer"
                onClick={toggleCollapse}
              />
            )}

            {isSearchOn && (
              <div class="relative w-full">
                <input
                  type="search"
                  class="p-2 w-full z-20 text-sm text-gray-900 bg-gray-50 rounded-lg focus:outline-none border border-gray-300"
                  placeholder="Search.."
                  onChange={(e) => setSearchTerm(e.target.value)}
                  autoFocus
                  required
                />
              </div>
            )}

            {!collapsed && (
              <Search
                onClick={(e) => {
                  setIsSearchOn(!isSearchOn);
                  setSearchTerm('');
                }}
                className="text-[#7a7c7c] cursor-pointer"
              />
            )}
          </div>

          {/* Mobile sidebar */}
          <div className="flex items-center justify-between gap-2 p-0 lg:p-2 lg:hidden max-h-10">
            {isSearchOn && (
              <div class={`relative group-input w-full`}>
                <input
                  type="search"
                  class="p-2 w-full z-20 text-sm text-gray-900 bg-gray-50 rounded-lg focus:outline-none border border-gray-300"
                  placeholder="Search.."
                  onChange={(e) => setSearchTerm(e.target.value)}
                  required
                />
              </div>
            )}
            <Search
              onClick={() => {
                setIsSearchOn(!isSearchOn);
                setSearchTerm('');
              }}
              className="text-[#7a7c7c] cursor-pointer"
            />
            <button onClick={() => setIsOpen(false)}>
              <X className="text-[#7a7c7c]" />
            </button>
          </div>

          {/* New Chat */}
          <div
            className={`p-3  hover:bg-[#eeeeee] rounded-md items-center${
              activeChatId === '' ? 'font-bold bg-[#eee]' : ''
            }`}
          >
            <button
              onClick={() => {
                navigate(`/chat`);
                setActiveChatId('');
                setIsOpen(false);
              }}
              className="flex items-center gap-2 text-[#7A7C7C] w-full hover:text-[#343a3a] transition-all"
            >
              <img src={MESSAGE_ICON} alt=" msg-icon" className="size-6" />
              {!collapsed && <span>New Chat</span>}
            </button>
          </div>

          {/* History */}
          <nav className="space-y-4">
            <ChatHistory
              searchTerm={searchTerm}
              onItemClick={() => setIsOpen(false)}
            />
          </nav>

          {/* Log out button for mobile. Hidden more than lg screen */}
          <button
            className="block mx-auto w-fit px-4 py-1 text-[#002231] border-2 border-[#CCCCCC] rounded lg:hidden"
            onClick={logout}
          >
            Logout
          </button>
        </div>
      </div>
    </>
  );
}
